module.exports = __webpack_public_path__ + "fonts/5a0408e329df3b3c47fdcdf5e59f1273.svg";